export default function SafetyHarborComparisonSection() {
  return (
    <section id="comparison" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Why Choose Us</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Fast Passport Center vs. Doing It Yourself
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            See how our registered courier service compares to the standard DIY passport process for Safety Harbor residents.
          </p>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[700px]">
              <thead>
                <tr className="bg-[#1A365D]">
                  <th className="text-left text-white font-bold text-sm px-6 py-4">Factor</th>
                  <th className="text-center text-[#F6C344] font-bold text-sm px-6 py-4">
                    <i className="ri-shield-check-line mr-1"></i>
                    Fast Passport Center
                  </th>
                  <th className="text-center text-white/60 font-bold text-sm px-6 py-4">DIY / Standard Process</th>
                </tr>
              </thead>
              <tbody>
                {[
                  {
                    factor: "Processing Speed",
                    fpc: "24 hours to 9 days — your choice",
                    diy: "7–11 weeks routine; 2–3 weeks expedited by mail",
                  },
                  {
                    factor: "Agency Appointment",
                    fpc: "Not required — we use our reserved slots",
                    diy: "You must book your own appointment (often unavailable)",
                  },
                  {
                    factor: "Document Review",
                    fpc: "Expert review before submission — reduces rejections",
                    diy: "You review your own forms — errors cause delays",
                  },
                  {
                    factor: "Travel to Agency",
                    fpc: "None — ship overnight from Safety Harbor or Dunedin",
                    diy: "Drive to Tampa or Miami for in-person appointments",
                  },
                  {
                    factor: "Live Support",
                    fpc: "Real humans via phone, email, and chat",
                    diy: "Limited government support; mostly automated",
                  },
                  {
                    factor: "Status Updates",
                    fpc: "Email updates at every stage of processing",
                    diy: "Minimal tracking; long periods of no information",
                  },
                  {
                    factor: "Error Correction",
                    fpc: "We catch and fix errors before agency submission",
                    diy: "Errors delay processing by weeks or require restart",
                  },
                  {
                    factor: "Return Shipping",
                    fpc: "Secure overnight return shipping included",
                    diy: "Standard USPS mail (1–2 weeks delivery time)",
                  },
                ].map((row, i) => (
                  <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-[#F7F8FA]"}>
                    <td className="text-[#1A365D] font-bold text-sm px-6 py-4">{row.factor}</td>
                    <td className="text-gray-700 text-sm px-6 py-4 text-center">
                      <span className="inline-flex items-center gap-1.5">
                        <i className="ri-check-line text-green-500"></i>
                        {row.fpc}
                      </span>
                    </td>
                    <td className="text-gray-500 text-sm px-6 py-4 text-center">{row.diy}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            {
              icon: "ri-time-line",
              title: "Save Weeks of Waiting",
              desc: "Our courier service submits your application within 24–48 hours of receiving your documents. The standard process can take months.",
            },
            {
              icon: "ri-map-pin-line",
              title: "No Drive to Tampa or Miami",
              desc: "The closest regional passport agency to Safety Harbor is in Tampa, with limited appointments. We eliminate that drive entirely — ship from any UPS or FedEx in Pinellas County.",
            },
            {
              icon: "ri-shield-check-line",
              title: "A+ BBB Rated & Registered",
              desc: "We are a registered U.S. Department of State courier with an A+ BBB rating and 20+ years of experience. Your documents are in expert hands.",
            },
          ].map((item, i) => (
            <div key={i} className="bg-white rounded-lg border border-gray-200 p-6 hover:border-[#F6C344] transition-all duration-200">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
                <i className={`${item.icon} text-[#1A365D] text-lg`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{item.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}